import api from "@/utils/axios";

/**
 * Signed MOA API
 */

/**
 * GET all Signed MOAs
 * Optional filters: section_id, status
 */
export const getAllSignedMoas = (params = {}) =>
    api.get("/api/signed-moa", { params });

/**
 * GET a Signed MOA by ID
 */
export const getSignedMoaById = (id) =>
    api.get(`/api/signed-moa/${id}`);

/**
 * CREATE new Signed MOAs (supports multiple file uploads)
 * Payload should be FormData including:
 * - section_id (required)
 * - company (required)
 * - status (optional)
 * - files[] (required)
 */
export const createSignedMoa = (payload) => {
    const config = payload instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
    return api.post("/api/signed-moa", payload, config);
};

/**
 * UPDATE a Signed MOA by ID
 * Accepts metadata + optional file replacement
 * If updating file, use FormData with field "file"
 */
export const updateSignedMoa = (id, payload) => {
    const config = payload instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
    return api.put(`/api/signed-moa/${id}`, payload, config);
};

/**
 * DELETE a Signed MOA by ID
 * Hard delete
 */
export const deleteSignedMoa = (id) =>
    api.delete(`/api/signed-moa/${id}`);

/**
 * DOWNLOAD a Signed MOA file by ID
 * filename is optional; defaults to MOA's original name
 */
export const downloadSignedMoa = async (id, filename) => {
    const response = await api.get(`/api/signed-moa/download/${id}`, {
        responseType: "blob",
    });

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", filename || "signed_moa");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
};